import { ISelectType } from "@4uhub/lib4uhub";
import { GlobalAxios } from "../axios/axios-config";
import {
  I4uBusAutomation,
  IExamMachineModality,
  IFileIntegration,
  IFileIntegrationCommand,
} from "../models/uBus-automation-robot";

const AUTOMATION_ROBOT_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/4uBusAutomationRobot";

export const createFileIntegration = (item: IFileIntegrationCommand) => {
  return GlobalAxios.post(AUTOMATION_ROBOT_ROUTE, item);
};

export const getFileIntegrationById = (id: string) => {
  return GlobalAxios.get<IFileIntegration>(AUTOMATION_ROBOT_ROUTE + "/" + id);
};

export const updateFileIntegrationById = ({
  item,
  id,
}: {
  item: IFileIntegrationCommand;
  id: string;
}) => {
  return GlobalAxios.put(AUTOMATION_ROBOT_ROUTE + "/" + id, item);
};

export const list4uBusAutomations = (params?: any) => {
  return GlobalAxios.get<I4uBusAutomation[]>(
    AUTOMATION_ROBOT_ROUTE + "/4uBusAutomation/list",
    { params },
  );
};

export const list4uBusAutomationExecutions = (params?: any) => {
  return GlobalAxios.get<ISelectType[]>(
    AUTOMATION_ROBOT_ROUTE + "/4uBusAutomationExecution/list",
    {
      params,
      paramsSerializer: {
        indexes: null,
      },
    },
  );
};

export const listExamMachines = (params?: any) => {
  return GlobalAxios.get<ISelectType[]>(
    AUTOMATION_ROBOT_ROUTE + "/ExamMachine/list",
    {
      params,
      paramsSerializer: {
        indexes: null,
      },
    },
  );
};

export const listExamMachineModality = () => {
  return GlobalAxios.get<IExamMachineModality[]>(
    AUTOMATION_ROBOT_ROUTE + "/ExamMachineModality/list",
  );
};
